module.exports = __webpack_public_path__ + "static/media/01-usa.8a2a41fe.png";